import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { createBrowserHistory as createHistory } from "history";
import {returnCompleteFilterEntry} from "./FilterService";
import QueryString from "./URLHelper/QueryString";
const CryptoJS = require("crypto-js");

function toSingleValue(val) {
    return Array.isArray(val) ? val[val.length - 1] : val;
}


function parseFiltersFromQueryParams(filters, configJson) {
    var enrichedFilters;
    if(configJson) {
        if (filters){
            filters = JSON.parse(filters);
            enrichedFilters = filters.map(function (filterFromURL) {
                var currentLabelInfos = configJson.filterMenu.find(function (infosFromConfig) {
                    return infosFromConfig.field === filterFromURL[0];
                });
                return returnCompleteFilterEntry(filterFromURL[0],
                    currentLabelInfos.label[localStorage.getItem('language')],
                    currentLabelInfos.color,
                    filterFromURL[1],
                    currentLabelInfos.filterType,
                    currentLabelInfos.sourceType,
                    currentLabelInfos.requestObjectFieldType)
            });
        }

        enrichedFilters && enrichedFilters.sort(function (a, b) {
            return a.color.localeCompare(b.color);
        });
        return enrichedFilters;
    } else {
        return filters
    }
}


function parseSearchTermFromQueryParams(queryParams) {
    var searchTerm = toSingleValue(queryParams.q);
    if (!searchTerm)
        searchTerm = ""
    return searchTerm
}

function parseSortFromQueryParams(queryParams, defaultValues) {
    var sortField = toSingleValue(queryParams["sort-field"]);
    if (!sortField)
        sortField = defaultValues.value
    var sortDirection = toSingleValue(queryParams["sort-direction"]);
    if (!sortDirection)
        sortDirection = defaultValues.direction
    if (sortField) return {sortField : sortField, sortDirection :sortDirection};
    return [];
}

function parseGuiLanguageFromQueryParams(queryParams) {
    var guiLanguage = queryParams["guiLanguage"]
    if (!guiLanguage) {
        localStorage.setItem('language', 'de');
        guiLanguage = localStorage.getItem('language')
    }

    return guiLanguage
}

function parseIDFromQueryParams(queryParams) {
    var id = queryParams["id"]
    return id;
}

//The Function Below To Decrypt Text
const decryptWithAES = (ciphertext) => {
    if(ciphertext){
        const passphrase = localStorage.getItem("sec");
        if (passphrase){
            const bytes = CryptoJS.AES.decrypt(ciphertext, passphrase);
            let originalText;
            try {
                originalText = bytes.toString(CryptoJS.enc.Utf8);
            } catch (error) {
                console.error("WrongPW");
            }

            return originalText;
        }

    }
    return ciphertext;
};

function decryptJwtToken(jwt) {
    return decryptWithAES(decodeURIComponent(jwt))
}

function paramsToState(queryParams, configJson) {
    const defaultValues = configJson.sortings.find((element) => element.isDefault)
    var sorting = parseSortFromQueryParams(queryParams, defaultValues)
    var state = {
        id: parseIDFromQueryParams(queryParams),
        filters: parseFiltersFromQueryParams(queryParams.filters, configJson),
        searchTerm: parseSearchTermFromQueryParams(queryParams),
        sortField: sorting.sortField,
        sortDirection: sorting.sortDirection,
        guiLanguage: parseGuiLanguageFromQueryParams(queryParams),
        jwt: decryptJwtToken(queryParams.jwt)
    };
    //console.log(state)
    return Object.keys(state).reduce(function (acc, key) {
        var value = state[key];
        if (value) acc[key] = value;
        return acc;
    }, {});
}

export function stateToParams(_ref, addIDToString) {
    // If the app fails here it is probably because we don't have an URLState which is essential to the application
    var reducedFilter = _ref.filters && _ref.filters.map((f) => (
        [f.field, f.values]
    ));
    reducedFilter = JSON.stringify(reducedFilter);

    var searchTerm = _ref.searchTerm,
        filters = reducedFilter,
        sortDirection = _ref.sortDirection,
        sortField = _ref.sortField,
        id =  _ref.id ,
        guiLanguage = _ref.guiLanguage;
    var params = {};
    if(guiLanguage) params.guiLanguage = guiLanguage;
    if (searchTerm) params.q = searchTerm;
    if (id && addIDToString) params.id = id;


    if (filters && filters.length > 0) {
        params["filters"] = filters;
    }

    if (sortField) {
        params["sort-field"] = sortField;
        params["sort-direction"] = sortDirection;
    }

    return params;
}

export function stateToQueryString(state, addIDToString) {
    return QueryString.stringify(stateToParams(state, addIDToString));
}
/**
 * The URL Manager is responsible for synchronizing state between
 * SearchDriver and the URL. There are 3 main cases we handle when
 * synchronizing:
 *
 * 1. When the app loads, SearchDriver will need to
 * read the current state from the URL, in order to perform the search
 * expressed by the query string. `getStateFromURL` is used for this case.
 *
 * 2. When the URL changes as a result of `pushState` or `replaceState`,
 * SearchDriver will need to be notified and given the updated state, so that
 * it can re-run the current search. `onURLStateChange` is used for this case.
 *
 * 3. When state changes internally in the SearchDriver, as a result of an
 * Action, it will need to notify the URLManagerService of the change. `pushStateToURL`
 * is used for this case.
 */


var URLManagerService =
    /*#__PURE__*/
    function () {
        function URLManager() {
            _classCallCheck(this, URLManager);

            this.history = createHistory();
        }
        /**
         * Parse the current URL into application state
         *
         * @return {Object} - The parsed state object
         */


        _createClass(URLManager, [{
            key: "getStateFromURL",
            value: function getStateFromURL(configJson) {
                return paramsToState(QueryString.parse(this.history.location.search), configJson);
            }
            /**
             * Push the current state of the application to the URL
             *
             * @param {Object} state - The entire current state from the SearchDriver
             * @param {boolean} options
             * @param {boolean} options.replaceUrl - When pushing state to the URL, use history 'replace'
             * rather than 'push' to avoid adding a new history entry
             */

        }, {
            key: "pushStateToURL",
            value: function pushStateToURL(state) {
                this.history = createHistory();
                var searchString ;
                searchString = "?".concat(stateToQueryString(state, true))

                this.lastPushSearchString = searchString;
                var navigationFunction = this.history.replace;
                navigationFunction({
                    search: searchString
                });


                return "?".concat(stateToQueryString(state, false));
            }
            /**
             * Add an event handler to be executed whenever state is pushed to the URL
             *
             * @callback requestCallback
             * @param {Object} state - Updated application state parsed from the new URL
             *
             * @param {requestCallback} callback
             */

        }, {
            key: "onURLStateChange",
            value: function onURLStateChange(callback) {
                var _this = this;

                this.unlisten = this.history.listen(function (location) {
                    // If this URL is updated as a result of a pushState request, we don't
                    // want to notify that the URL changed.
                    if ("?".concat(_this.lastPushSearchString) === location.search) return; // Once we've decided to return based on lastPushSearchString, reset
                    // it so that we don't break back / forward button.

                    _this.lastPushSearchString = "";
                    callback(paramsToState(QueryString.parse(location.search)));
                });
            }
        }, {
            key: "tearDown",
            value: function tearDown() {
                this.unlisten();
            }
        }]);

        return URLManager;
    }();

export { URLManagerService as default };
